<div class="page-wrapper playground-page">

  <div class="page-header">
    <div class="page-title">
      <svg class="page-title__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 4C1.5 2.89543 2.39543 2 3.5 2H12.5C13.6046 2 14.5 2.89543 14.5 4V12C14.5 13.1046 13.6046 14 12.5 14H3.5C2.39543 14 1.5 13.1046 1.5 12V4ZM4.14645 4.64645C4.34171 4.45118 4.65829 4.45118 4.85355 4.64645L6.35355 6.14645C6.54882 6.34171 6.54882 6.65829 6.35355 6.85355L4.85355 8.35355C4.65829 8.54882 4.34171 8.54882 4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L5.29289 6.5L4.14645 5.35355C3.95118 5.15829 3.95118 4.84171 4.14645 4.64645ZM7 7.5C6.72386 7.5 6.5 7.72386 6.5 8C6.5 8.27614 6.72386 8.5 7 8.5H9C9.27614 8.5 9.5 8.27614 9.5 8C9.5 7.72386 9.27614 7.5 9 7.5H7Z" fill="currentColor"/>
      </svg>
      <h1 class="page-title__text">Playground</h1>
    </div>
    <p class="page-title__sub">Start exploring the -mila. search API. <a href="#" class="link">Read our documentation</a></p>
  </div>

  <!-- Endpoint switcher: one row across the page. -->
  <nav class="endpoint-bar" aria-label="Endpoints">
    <!-- On phones this row scrolls sideways; the Tour button stays outside it. -->
    <div class="endpoint-bar__groups">
    <div class="endpoint-group">
      <span class="endpoint-group__label">Find</span>
      <div class="endpoint-group__items">
        @for (e of findEndpoints; track e.path) {
          <a class="endpoint-tab" [routerLink]="e.link" routerLinkActive="endpoint-tab--active" [routerLinkActiveOptions]="{ exact: true }"
             ariaCurrentWhenActive="page" [title]="e.hint">
            <span class="endpoint-tab__path">{{ e.path }}</span>
          </a>
        }
      </div>
    </div>

    <div class="endpoint-group">
      <span class="endpoint-group__label">Fetch</span>
      <div class="endpoint-group__items">
        @for (e of fetchEndpoints; track e.path) {
          @if (isSuperadmin) {
            <a class="endpoint-tab" [routerLink]="e.link" routerLinkActive="endpoint-tab--active" ariaCurrentWhenActive="page"
               [title]="e.hint + ' (not ready)'">
              <span class="endpoint-tab__path">{{ e.path }}</span>
              <span class="endpoint-tab__soon" aria-label="Not ready"></span>
            </a>
          } @else {
            <span class="endpoint-tab endpoint-tab--disabled" aria-disabled="true" title="Coming soon">
              <span class="endpoint-tab__path">{{ e.path }}</span>
              <span class="endpoint-tab__soon" aria-label="Coming soon"></span>
            </span>
          }
        }
      </div>
    </div>
    </div>

    @if (endpointHint()) {
      <p class="endpoint-bar__hint">{{ endpointHint() }}</p>
    }
    @if (intro()) {
      <!-- Behind the first-visit pop-up: dims the page, and a click on it closes the pop-up. -->
      @if (tourHint()) {
        <div class="tour-hint-curtain" (click)="dismissTourHint()" aria-hidden="true"></div>
      }
      <span class="endpoint-bar__tour-wrap" [class.endpoint-bar__tour-wrap--lifted]="tourHint()">
      <button type="button" class="endpoint-bar__tour" [class.endpoint-bar__tour--new]="tourNew()" data-tour="replay" (click)="startTour()"
              [title]="tourNew() ? 'New: a short walkthrough of this page' : 'A short walkthrough of this page'">
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.4"/><path d="M10.4 5.6 9 9 5.6 10.4 7 7l3.4-1.4z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>
        Tour
        @if (tourNew()) {
          <span class="endpoint-bar__tour-dot" aria-label="New"></span>
        }
      </button>

      <!-- First visit to this endpoint: offers its tour, without holding the page. -->
      @if (tourHint()) {
        <div class="tour-hint" role="dialog" aria-labelledby="tour-hint-title">
          <button type="button" class="tour-hint__close" aria-label="Close" (click)="dismissTourHint()">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          </button>
          <p class="tour-hint__title" id="tour-hint-title"><code>{{ endpointPath() }}</code> has its own tour</p>
          <p class="tour-hint__text">A short walkthrough of this page and what it returns.</p>
          <div class="tour-hint__actions">
            <button type="button" class="tour-hint__later" (click)="dismissTourHint()">Not now</button>
            <button type="button" class="tour-hint__go" (click)="startTour()">Take the tour</button>
          </div>
        </div>
      }
      </span>
    }
  </nav>

  <!-- The first tour is on its way (see onActivate). -->
  @if (tourLoading()) {
    <div class="pg-tour-loading" role="status" aria-label="Preparing your tour">
      <div class="pg-tour-loading__spinner">
        @for (i of tourSpokes; track i) {
          <i [style.transform]="'rotate(' + i * 30 + 'deg)'" [style.animation-delay]="(i - 12) / 12 + 's'"></i>
        }
      </div>
    </div>
  }

  <!-- Phones: one panel at a time (see isPhone in playground.ts). -->
  @if (isPhone() && activeChild) {
    <div class="pg-phone-tabs" #phoneTabs role="tablist" aria-label="Playground panels" data-tour="phone-tabs">
      <button type="button" role="tab" class="pg-phone-tabs__tab" [class.pg-phone-tabs__tab--active]="phoneTab() === 'request'"
              [attr.aria-selected]="phoneTab() === 'request'" (click)="setPhoneTab('request')">Request</button>
      <button type="button" role="tab" class="pg-phone-tabs__tab" [class.pg-phone-tabs__tab--active]="phoneTab() === 'response'"
              [attr.aria-selected]="phoneTab() === 'response'" data-tour="phone-response" (click)="setPhoneTab('response')">
        Response
        @if (responseUnseen()) {
          <span class="pg-phone-tabs__dot" aria-label="New result"></span>
        }
      </button>
      <button type="button" role="tab" class="pg-phone-tabs__tab" [class.pg-phone-tabs__tab--active]="phoneTab() === 'code'"
              [attr.aria-selected]="phoneTab() === 'code'" data-tour="phone-code" (click)="setPhoneTab('code')">Code</button>
    </div>
  }

  <div class="playground__area" #area>

    <!-- ── Left: the request form, with price + Run pinned under it. ── -->
    <div class="form-panel">
      <!-- The form scrolls inside this box; the footer below it stays put. -->
      <div class="form-panel__scroll" #formScroll (scroll)="updateFormMore()" [class.pg-phone-hidden]="isPhone() && phoneTab() !== 'request'">
        <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate()"
                       (attach)="onActivate($any($event))" (detach)="onDeactivate()"></router-outlet>
      </div>

      @if (activeChild; as child) {
        <div class="form-panel__footer" data-tour="run" [class.form-panel__footer--raised]="formMore()" [style.margin-right.px]="formGutter()">
          <div class="cost-info">
            <div class="cost-info__row">
              <span class="cost-info__amount">{{ child.estimatedPrice.totalCents | money }}</span>
              @if (currency(); as cur) {
                <span class="cost-info__amount">{{ cur | uppercase }}</span>
              }
              @if (noApiKey()) {
                <span class="form-hint cost-info__key">No active API key. <a routerLink="/api-keys/create" class="link">Create one</a> to run queries.</span>
              } @else if (apiKey.selected(); as key) {
                <span class="form-hint cost-info__key">
                  will be billed to
                  <span class="dropdown" (appClickOutside)="keyMenuOpen.set(false)">
                    <button type="button" class="cost-info__key-trigger" data-tour="api-key" aria-haspopup="listbox"
                            [attr.aria-expanded]="keyMenuOpen()" [attr.aria-label]="'API key: ' + key.name + '. Change'" (click)="toggleKeyMenu($event)">
                      {{ key.name }}
                      <svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>
                    @if (keyMenuOpen()) {
                      <span class="dropdown__menu dropdown__menu--left cost-info__key-menu" role="listbox" aria-label="API key">
                        @for (k of apiKey.keys(); track k.id) {
                          <button type="button" role="option" class="dropdown__item" [class.dropdown__item--active]="k.id === key.id"
                                  [attr.aria-selected]="k.id === key.id" (click)="apiKey.select(k); keyMenuOpen.set(false)">{{ k.name }}</button>
                        }
                      </span>
                    }
                  </span>
                </span>
              } @else {
                <span class="form-hint">will be used for this query</span>
              }
            </div>
            <span class="form-hint cost-info__estimated"><svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="flex-shrink:0;"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8.75 3.75C8.75 3.33579 8.41421 3 8 3C7.58579 3 7.25 3.33579 7.25 3.75V8C7.25 8.41421 7.58579 8.75 8 8.75H11.25C11.6642 8.75 12 8.41421 12 8C12 7.58579 11.6642 7.25 11.25 7.25H8.75V3.75Z" fill="currentColor"/></svg>Estimated: 2 – 10 sec</span>
          </div>
          <div class="cost-info__actions">
            @if (isPhone()) {
              <div class="dropdown" (appClickOutside)="runMenuOpen.set(false)">
                <button type="button" class="btn--secondary cost-info__more" aria-label="More actions" aria-haspopup="menu"
                        [attr.aria-expanded]="runMenuOpen()" (click)="toggleRunMenu($event)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="3.5" cy="8" r="1.25" fill="currentColor"/><circle cx="8" cy="8" r="1.25" fill="currentColor"/><circle cx="12.5" cy="8" r="1.25" fill="currentColor"/></svg>
                </button>
                @if (runMenuOpen()) {
                  <div class="dropdown__menu dropdown__menu--left cost-info__menu" role="menu">
                    <button type="button" role="menuitem" class="dropdown__item" (click)="openResetConfirm()">Reset query</button>
                  </div>
                }
              </div>
            } @else {
              <button class="btn--secondary" (click)="openResetConfirm()">Reset</button>
            }
            <!-- ⌘/Ctrl+Enter also runs it (see onKeydown); named in the tooltip, not on the button. -->
            <button class="btn--primary" [disabled]="child.isLoading || noApiKey()" (click)="run(child)" [attr.aria-keyshortcuts]="isMac ? 'Meta+Enter' : 'Control+Enter'"
                    [title]="'Run query (' + (isMac ? '⌘' : 'Ctrl') + ' + Enter)'">
              <svg class="btn--primary__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 2.69879C3 1.83325 3.94076 1.29811 4.6894 1.74695L13.6253 7.04816C14.3613 7.48928 14.3613 8.51072 13.6253 8.95184L4.6894 14.253C3.94076 14.7019 3 14.1667 3 13.3012V2.69879Z" fill="currentColor"/></svg>
              {{ child.isLoading ? 'Running…' : 'Run query' }}
            </button>
          </div>
        </div>
      }
    </div>

    <!-- ── Right: the workspace. Request code and Response are two independent
         panels, stacked or side by side with a draggable divider; the code
         panel can collapse to its header. ── -->
    @if (activeChild; as child) {
      <aside class="playground__side" #side [class.pg-phone-hidden]="isPhone() && phoneTab() === 'request'">
        <!-- Collapsed, the code shrinks to its header: a bar across the top
             when stacked; side by side, a bar at the top of its own column,
             so the response keeps its width. -->
        @if (isPhone()) {
          <!-- Both panels stay mounted; the tabs only show one, so a result
               view keeps its own state (sub-tab, scroll) between tabs. -->
          <div class="workspace workspace--phone">
            <div class="workspace__phone-slot" [class.pg-phone-hidden]="phoneTab() !== 'code'">
              <ng-container *ngTemplateOutlet="codePanel; context: { $implicit: child }" />
            </div>
            <div class="workspace__phone-slot" [class.pg-phone-hidden]="phoneTab() !== 'response'">
              <ng-container *ngTemplateOutlet="responsePanel; context: { $implicit: child }" />
            </div>
          </div>
        } @else {
        <div class="workspace" [class.workspace--collapsed]="codeCollapsed() && effectiveLayout() !== 'side'"
             [class.workspace--code-folded]="codeCollapsed() && effectiveLayout() === 'side'">
          @if (codeCollapsed() && effectiveLayout() !== 'side') {
            <ng-container *ngTemplateOutlet="codePanel; context: { $implicit: child }" />
            <ng-container *ngTemplateOutlet="responsePanel; context: { $implicit: child }" />
          } @else if (effectiveLayout() === 'side') {
            <app-split-pane class="workspace__split" orientation="horizontal" [(ratio)]="sideRatio" [defaultRatio]="0.46"
                            [minStart]="320" [minEnd]="360" label="Resize request code and response">
              <div splitStart class="workspace__slot"><ng-container *ngTemplateOutlet="codePanel; context: { $implicit: child }" /></div>
              <div splitEnd class="workspace__slot"><ng-container *ngTemplateOutlet="responsePanel; context: { $implicit: child }" /></div>
            </app-split-pane>
          } @else {
            <app-split-pane class="workspace__split" orientation="vertical" [(ratio)]="stackedRatio" [defaultRatio]="0.42"
                            [minStart]="140" [minEnd]="220" label="Resize request code and response">
              <div splitStart class="workspace__slot"><ng-container *ngTemplateOutlet="codePanel; context: { $implicit: child }" /></div>
              <div splitEnd class="workspace__slot"><ng-container *ngTemplateOutlet="responsePanel; context: { $implicit: child }" /></div>
            </app-split-pane>
          }
        </div>
        }
      </aside>

      <!-- Stacked / side by side: in the code header, open or collapsed. -->
      <ng-template #layoutButtons>
        <div class="code-pane__layout" role="group" aria-label="Layout">
          <button type="button" class="code-pane__icon" [class.code-pane__icon--active]="effectiveLayout() === 'stacked'"
                  title="Stacked" aria-label="Stacked layout" [attr.aria-pressed]="effectiveLayout() === 'stacked'" (click)="setLayout('stacked')">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="2" y="2" width="12" height="5" rx="1.25" stroke="currentColor" stroke-width="1.4"/><rect x="2" y="9" width="12" height="5" rx="1.25" stroke="currentColor" stroke-width="1.4"/></svg>
          </button>
          <button type="button" class="code-pane__icon" [class.code-pane__icon--active]="effectiveLayout() === 'side'"
                  [disabled]="narrow()" [title]="narrow() ? 'Side by side needs a wider window' : 'Side by side'"
                  aria-label="Side by side layout" [attr.aria-pressed]="effectiveLayout() === 'side'" (click)="setLayout('side')">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="2" y="2" width="5" height="12" rx="1.25" stroke="currentColor" stroke-width="1.4"/><rect x="9" y="2" width="5" height="12" rx="1.25" stroke="currentColor" stroke-width="1.4"/></svg>
          </button>
        </div>
      </ng-template>

      <!-- ── Request code panel ── -->
      <ng-template #codePanel let-c>
        <section class="code-pane" data-tour="code" aria-label="Request code">
          <header class="code-pane__head" (click)="onCodeHeadClick($event)">
            <div class="code-pane__title">
              <span class="code-pane__label">Request</span>
              <span class="code-pane__endpoint"><span class="code-pane__method">POST</span>{{ endpointPath() }}</span>
              <!-- Collapsed: what the request is about, instead of controls for code you can't see. -->
              @if (codeFolded() && c.requestSummary) {
                <span class="code-pane__summary" [title]="c.requestSummary">“{{ c.requestSummary }}”</span>
              }
            </div>

            @if (codeFolded()) {
              <div class="code-pane__actions">
                <ng-container *ngTemplateOutlet="layoutButtons" />
                <button type="button" class="code-pane__show" (click)="toggleCode()" aria-expanded="false">
                  Show code
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
              </div>
            } @else {
            <div class="code-pane__langs" role="tablist" aria-label="Language">
              @for (lang of codeLanguages; track lang.id) {
                <button type="button" role="tab" class="code-pane__lang" [class.code-pane__lang--active]="c.activeLanguage === lang.id"
                        [attr.aria-selected]="c.activeLanguage === lang.id" (click)="c.setLanguage(lang.id); codeCollapsed.set(false)">{{ lang.label }}</button>
              }
            </div>

            <div class="code-pane__actions">
              <button type="button" class="code-pane__btn" (click)="c.copySnippet()" [attr.aria-label]="c.copied ? 'Copied' : 'Copy request code'">
                @if (c.copied) {
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  Copied
                } @else {
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="5" y="5" width="8.5" height="8.5" rx="1.75" stroke="currentColor" stroke-width="1.4"/><path d="M10.5 3.25A1.75 1.75 0 008.75 1.5H4.25A1.75 1.75 0 002.5 3.25v4.5c0 .97.78 1.75 1.75 1.75" stroke="currentColor" stroke-width="1.4"/></svg>
                  Copy
                }
              </button>

              <ng-container *ngTemplateOutlet="layoutButtons" />

              <button type="button" class="code-pane__icon" (click)="toggleCode()"
                      [attr.aria-expanded]="!codeFolded()" [attr.aria-label]="codeFolded() ? 'Show request code' : 'Hide request code'"
                      [title]="codeFolded() ? 'Show request code' : 'Hide request code'">
                <svg class="code-pane__chevron" [class.code-pane__chevron--down]="codeFolded()" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 10l4-4 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
            }
          </header>

          @if (!codeFolded()) {
            <div class="code-pane__body">
              <pre class="code-pre code-pane__pre" [innerHTML]="(c.codeSnippet | codeHighlight: c.activeLanguage) | codeLines"></pre>
            </div>
          }
        </section>
      </ng-template>

      <!-- ── Response panel ── -->
      <ng-template #responsePanel let-c>
        <section class="response-pane" data-tour="response" aria-label="Response">
          <header class="response-card__head">
            <div class="response-card__tabs" role="tablist">
              <button type="button" role="tab" class="response-card__tab" [class.response-card__tab--active]="responseTab() === 'response'"
                      [attr.aria-selected]="responseTab() === 'response'" (click)="setResponseTab('response')">Response</button>
              @if (viewOf(c)) {
                <button type="button" role="tab" class="response-card__tab" [class.response-card__tab--active]="responseTab() === 'json'"
                        [attr.aria-selected]="responseTab() === 'json'" (click)="setResponseTab('json')">JSON</button>
              }
              <button type="button" role="tab" class="response-card__tab" [class.response-card__tab--active]="responseTab() === 'headers'"
                      [attr.aria-selected]="responseTab() === 'headers'" (click)="setResponseTab('headers')">Headers</button>
            </div>

            <div class="response-card__status" aria-live="polite">
              @if (c.isLoading) {
                <span class="response-card__dot response-card__dot--busy"></span>Running…
              } @else {
                @switch (c.status) {
                  @case ('idle') {
                    <span class="response-card__dot"></span>Not run yet
                  }
                  @case ('ok') {
                    <span class="response-card__dot response-card__dot--ok"></span>
                    <strong>{{ c.runInfo?.status ?? 200 }} OK</strong>
                    <span class="response-card__sep">·</span>{{ c.latencyMs | latency }}
                    <span class="response-card__sep">·</span>{{ c.credits }} credit{{ c.credits === 1 ? '' : 's' }}
                    @if (finishedAgo(c); as ago) {
                      <span class="response-card__sep">·</span>{{ ago }}
                    }
                  }
                  @case ('error') {
                    <span class="response-card__dot response-card__dot--error"></span><strong>Request failed</strong>
                  }
                }
              }
            </div>
          </header>

          <!-- Every run shows the loader, a re-run too: the last result would
               otherwise sit there (mixed with what's loading) until the new one lands. -->
          <div class="response-card__body" #responseBody>
            @if (c.isLoading) {
              <div class="response-loading" role="status">
                <div class="response-loading__head">
                  <span class="response-loading__spinner" aria-hidden="true"></span>
                  <span>{{ c.loadingLabel || 'Running your query' }}… <strong class="response-loading__elapsed">{{ elapsedSeconds() | number:'1.1-1' }} s</strong></span>
                  @if (c.loadingHint ?? 'usually 2–10 s'; as hint) {
                    <span class="response-loading__hint">{{ hint }}</span>
                  }
                </div>
                @if (viewOf(c) === 'answer') {
                  <!-- Like the result's first tab: the Answer | Sources switch, then the
                       answer card (claims too if structured was asked for). Sources
                       have their own tab, so no source rows here. -->
                  <div class="response-loading__answer" aria-hidden="true">
                    <div class="response-loading__seg">
                      <app-skeleton width="64px" height="26px" radius="7px"></app-skeleton>
                      <app-skeleton width="84px" height="26px" radius="7px"></app-skeleton>
                    </div>
                    <div class="response-loading__card response-loading__lines response-loading__lines--answer">
                      @if (c.loadingQuery) {
                        <p class="response-loading__question">{{ c.loadingQuery }}</p>
                      } @else {
                        <app-skeleton width="70px" height="12px"></app-skeleton>
                      }
                      <app-skeleton width="100%" height="13px"></app-skeleton>
                      <app-skeleton width="98%" height="13px"></app-skeleton>
                      <app-skeleton width="94%" height="13px"></app-skeleton>
                      <app-skeleton width="58%" height="13px"></app-skeleton>
                      @if (c.loadingFields?.has('structured')) {
                        <app-skeleton class="response-loading__gap" width="64px" height="11px"></app-skeleton>
                        <app-skeleton width="72%" height="12px"></app-skeleton>
                        <app-skeleton width="84%" height="12px"></app-skeleton>
                        <app-skeleton width="66%" height="12px"></app-skeleton>
                      }
                    </div>
                  </div>
                } @else {
                @if (viewOf(c) === 'image') {
                  <!-- A gallery, like the result: picture blocks in justified rows, no
                       text (the details are in the lightbox). Widths vary in a fixed
                       pattern, since the real proportions aren't known yet. -->
                  <ul class="response-loading__gallery" aria-hidden="true">
                    @for (w of galleryShapes; track $index) {
                      <li [style.flex-grow]="w * 100" [style.width.px]="w * 180"><i [style.padding-bottom.%]="100 / w"></i></li>
                    }
                  </ul>
                } @else {
                <!-- Shaped like the real results (rag: the passage list), and enough of
                     them to fill the panel; the extras are clipped with a fade. -->
                <div class="response-loading__grid" [class.response-loading__grid--list]="viewOf(c) === 'rag'" aria-hidden="true">
                  @for (i of skeletonCards; track i) {
                    <div class="response-loading__card">
                      @if (viewOf(c) === 'rag') {
                        <!-- Only what this run asked for: snippet, url and date always
                             come back; each include_* field only when it was on. -->
                        @let f = c.loadingFields;
                        <div class="response-loading__lines response-loading__lines--passage">
                          <app-skeleton width="100%" height="13px"></app-skeleton>
                          <app-skeleton width="97%" height="13px"></app-skeleton>
                          <app-skeleton width="62%" height="13px"></app-skeleton>
                          @if (f?.has('include_original_language_snippet')) {
                            <app-skeleton class="response-loading__action" width="140px" height="10px"></app-skeleton>
                          }
                        </div>
                        <div class="response-loading__source">
                          @if (f?.has('include_image_url')) {
                            <app-skeleton width="44px" height="44px" radius="8px"></app-skeleton>
                          }
                          <div class="response-loading__source-lines">
                            <div class="response-loading__meta">
                              @if (f?.has('include_favicon')) {
                                <app-skeleton width="14px" height="14px" radius="3px"></app-skeleton>
                              }
                              <app-skeleton width="180px" height="11px"></app-skeleton>
                            </div>
                            @if (f?.has('include_article_title')) {
                              <app-skeleton width="62%" height="12px"></app-skeleton>
                            }
                          </div>
                          @if (f?.has('include_relevance_score')) {
                            <app-skeleton width="52px" height="22px" radius="99px"></app-skeleton>
                          }
                        </div>
                      } @else if (viewOf(c) === 'search') {
                        <!-- An article card with only the fields this run asked for;
                             url always comes back, shown as the domain line. -->
                        @let f = c.loadingFields;
                        @if (f?.has('include_image_url')) {
                          <app-skeleton class="response-loading__media" width="100%" height="150px" radius="0"></app-skeleton>
                        }
                        <div class="response-loading__lines">
                          @if (f?.has('include_publication_date') || f?.has('include_indexation_date') || f?.has('include_relevance_score')) {
                            <div class="response-loading__meta">
                              @if (f?.has('include_publication_date') || f?.has('include_indexation_date')) {
                                <app-skeleton width="40%" height="11px"></app-skeleton>
                              }
                              @if (f?.has('include_relevance_score')) {
                                <app-skeleton class="response-loading__push" width="48px" height="20px" radius="99px"></app-skeleton>
                              }
                            </div>
                          }
                          @if (f?.has('include_title')) {
                            <app-skeleton width="92%" height="15px"></app-skeleton>
                            <app-skeleton width="64%" height="15px"></app-skeleton>
                          }
                          @if (f?.has('include_description')) {
                            <app-skeleton width="100%" height="11px"></app-skeleton>
                            <app-skeleton width="96%" height="11px"></app-skeleton>
                            <app-skeleton width="58%" height="11px"></app-skeleton>
                          }
                          @if (f?.has('include_author')) {
                            <app-skeleton width="34%" height="10px"></app-skeleton>
                          }
                          <div class="response-loading__meta response-loading__foot">
                            @if (f?.has('include_favicon')) {
                              <app-skeleton width="14px" height="14px" radius="3px"></app-skeleton>
                            }
                            <app-skeleton width="45%" height="11px"></app-skeleton>
                            @if (f?.has('include_language')) {
                              <app-skeleton class="response-loading__push" width="28px" height="16px" radius="99px"></app-skeleton>
                            }
                          </div>
                        </div>
                      } @else {
                        <div class="response-loading__lines">
                          <app-skeleton width="55%" height="12px"></app-skeleton>
                          <app-skeleton width="90%" height="16px"></app-skeleton>
                          <app-skeleton width="100%" height="12px"></app-skeleton>
                          <app-skeleton width="96%" height="12px"></app-skeleton>
                          <app-skeleton width="70%" height="12px"></app-skeleton>
                        </div>
                      }
                    </div>
                  }
                </div>
                }
                }
              </div>
            } @else if (c.status === 'error') {
              <div class="response-card__error" role="alert">
                <p class="response-card__error-title">The query didn't succeed</p>
                <p class="response-card__error-text">{{ c.errorMessage || 'Something went wrong running this query. Check the request and try again.' }}</p>
              </div>
            } @else if (!c.response) {
              <div class="response-card__empty">
                <svg class="response-card__empty-icon" width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">
                  <rect x="9" y="6" width="24" height="32" rx="3" stroke="currentColor" stroke-width="2"/>
                  <path d="M15 14h12M15 20h8M15 26h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="32" cy="32" r="7" stroke="currentColor" stroke-width="2" fill="var(--color-white)"/>
                  <path d="M37 37l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <p class="response-card__empty-title">Run a query to see the response here.</p>
                <p class="response-card__empty-text">{{ c.emptyHint || 'The API response will appear here once the query has run.' }}</p>
              </div>
            } @else {
              @switch (responseTab()) {
                @case ('response') {
                  @if (viewOf(c) === 'rag') {
                    <app-rag-results [result]="asRag(c.response)" (exampleQuestion)="tryExample($event)" />
                  } @else if (viewOf(c) === 'search') {
                    <app-search-results [result]="asSearch(c.response)" />
                  } @else if (viewOf(c) === 'answer') {
                    <app-answer-results [result]="asAnswer(c.response)" />
                  } @else if (viewOf(c) === 'image') {
                    <app-image-results [result]="asImage(c.response)" />
                  } @else {
                    <pre class="code-pre response-card__json" [innerHTML]="(rawJson(c) | json) | codeHighlight: 'json'"></pre>
                  }
                }
                @case ('json') {
                  <pre class="code-pre response-card__json" [innerHTML]="(rawJson(c) | json) | codeHighlight: 'json'"></pre>
                }
                @case ('headers') {
                  @if (c.runInfo; as run) {
                    <dl class="response-card__facts">
                      <div><dt>Status</dt><dd>{{ run.status }}</dd></div>
                      @if (run.apiKeyPrefix) { <div><dt>Billed to</dt><dd class="mono">{{ run.apiKeyPrefix }}…</dd></div> }
                      @if (run.messages.length) { <div><dt>Messages</dt><dd>{{ run.messages.join(' · ') }}</dd></div> }
                    </dl>
                    @if (headerEntries(c).length) {
                      <div class="response-card__table-wrap">
                        <table class="response-card__headers">
                          <tbody>
                            @for (h of headerEntries(c); track h[0]) {
                              <tr><th scope="row">{{ h[0] }}</th><td>{{ h[1] }}</td></tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    } @else {
                      <p class="response-card__muted">The API didn't return any headers for this run.</p>
                    }
                    @if (run.curl) {
                      <button type="button" class="btn--secondary response-card__curl" (click)="copyCurl(run.curl)">
                        {{ curlCopied() ? 'Copied' : 'Copy this request as cURL' }}
                      </button>
                    }
                  } @else {
                    <p class="response-card__muted">Headers aren't available for this endpoint yet.</p>
                  }
                }
              }
            }
          </div>
        </section>
      </ng-template>
    }

  </div>
</div>
